import $ from 'jquery'

export const bp = {
  sm: 576,
  md: 768,
  lg: 992,
  xl: 1200,
  xxl: 1440
}

const supportsCalcSize = window.CSS && CSS.supports('height', 'calc-size(auto, size)')
const collapseTimers = new WeakMap()

export class Core {

  static isProd () {
    const hostname = window.location.hostname.toLowerCase();
    const url = window.location.href.toLowerCase();

    // Check if we're in a local/development environment
    const devPatterns = [
      'local',
      'localhost',
      '127.0.0.1',
      '.test',
      '.dev',
      'staging',
      'preprod',
      '.mkt.',
    ];

    return !devPatterns.some(pattern => hostname.includes(pattern) || url.includes(pattern));
  }

  static isAdmin () {
    return $('body').hasClass('wp-admin')
  }

  static isAdminFront () {
    return $('body').hasClass('admin-bar')
  }

  /**
   * WordPress admin bar height (32px, 46px below 782px), 0 when not displayed
   *
   * @returns {number}
   */
  static getAdminBarHeight () {
    if (!Core.isAdminFront()) {
      return 0
    }

    const height = parseFloat(getComputedStyle(document.documentElement).getPropertyValue('--wp-admin--admin-bar--height'))

    return height || document.getElementById('wpadminbar')?.offsetHeight || 0
  }

  static getCurrentBp () {
    let window_width = $(window).width()

    if (window_width >= bp.xxl) {
      return 'xxl'
    } else if (window_width >= bp.xl) {
      return 'xl'
    } else if (window_width >= bp.lg) {
      return 'lg'
    } else if (window_width >= bp.md) {
      return 'md'
    } else if (window_width >= bp.sm) {
      return 'sm'
    } else {
      return 'xs'
    }
  }

  static scrollTo ($item, time) {
    if (! time) {
      time = 300
    }

    $('body, html').animate({
      scrollTop: $item.offset().top - $('header').height() - 50
    }, time)
  }

  static isBpGreaterThan (bpTest) {
    if (bp.hasOwnProperty(bpTest)) {
      let window_width = $(window).width()

      if (window_width > bp[bpTest]) {
        return true
      }
    }

    return false
  }

  static isBpLessThan (bpTest) {
    if (bp.hasOwnProperty(bpTest)) {
      let window_width = $(window).width()

      if (window_width <= bp[bpTest]) {
        return true
      }
    }

    return false
  }

  /**
   * Toggle the open class of an accordion whose height transitions to calc-size(auto, size).
   * Safari (all iOS browsers) and Firefox do not support calc-size(), so we animate the height in px.
   */
  static toggleCollapse (el, className, isOpen) {
    const style = window.getComputedStyle(el)

    if (supportsCalcSize || !style.transitionProperty.split(', ').includes('height')) {
      el.classList.toggle(className, isOpen)
      return
    }

    if (el.classList.contains(className) === isOpen) {
      return
    }

    const duration = Math.max(...style.transitionDuration.split(',').map(parseFloat)) * 1000
    const startHeight = el.offsetHeight

    clearTimeout(collapseTimers.get(el))

    // Measure the end height without transitions, then go back to the start state
    el.style.transition = 'none'
    el.style.height = ''
    el.classList.toggle(className, isOpen)
    const endHeight = el.offsetHeight
    el.classList.toggle(className, !isOpen)
    el.style.height = `${startHeight}px`
    el.offsetHeight // Force reflow

    el.style.transition = ''
    el.classList.toggle(className, isOpen)
    el.style.height = `${endHeight}px`

    // Give the height back to the CSS (auto when open, 0 when closed)
    collapseTimers.set(el, setTimeout(() => {
      el.style.height = ''
    }, duration + 50))
  }

  static activeBodyScroll () {
    $('html').removeClass('disable-overflow')
  }

  static disableBodyScroll () {
    $('html').addClass('disable-overflow')
  }

}
